import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'

export async function presignUrl(filename, nomination_id, is_logo = false) {
  const resp = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_file_presigned_url, { filename, nomination_id, is_logo })
  return resp.data
}

export function confirmFileAdded(id, files) {
   return httpSvc.post(DS_ROUTES.purple_ribbon_awards_file_confirm, { id, files })
}

export async function getNominationFiles(id) {
  const resp = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_nomination_files_get, { id })
  return { files: resp.data.files, logos: resp.data.logos }
}

export async function removeFile(id) {
  return httpSvc.post(DS_ROUTES.purple_ribbon_awards_file_remove, { id })
}
